import React from 'react';
import Loader from 'components/Loader';
import Item from './Item';
import Estrutura from './Estrutura';
import Processos from './Processos';

const Tabs = ({ tab, getLoading, ...props }) => {
  if (getLoading) {
    return <Loader />;
  }
  switch (tab) {
    case 0:
      return <Item {...props} />;
    case 1:
      return <Estrutura {...props} />;
    case 2:
      return <Processos {...props} />;
    default:
      return null;
  }
};

export default Tabs;
